import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import ConfirmCancelModal from 'src/presentation/components/forms/ConfirmCancelModal';
import useRouter from 'src/presentation/hooks/useRouter';
import messagingResource from 'src/actions/messaging/MessagingResource';
import voiceConfigResource from 'src/actions/voice/voiceConfigResource';

type useOnLeavePageType = {
  customText?: string;
  isModified: boolean;
  title: string;
};

export default function useOnLeavePage({ isModified, title, customText }: useOnLeavePageType) {
  const [isConfirmCancelModalVisible, setConfirmCancelModalVisible] = useState(false);

  const dispatch = useDispatch();
  const { history } = useRouter();

  // eslint-disable-next-line
  const resetAllErrors = async () => {
    dispatch(messagingResource.actions.resetErrors({}));
    dispatch(voiceConfigResource.actions.resetErrors({}));
  };

  const onClose = useCallback(
    navigateTo => {
      resetAllErrors();
      history.push(navigateTo);
    },
    [resetAllErrors, history]
  );

  const handleStay = useCallback(() => {
    setConfirmCancelModalVisible(false);
  }, [setConfirmCancelModalVisible]);

  const renderConfirmation = isModified && (
    <ConfirmCancelModal
      name={title}
      handleLeave={onClose}
      handleStay={handleStay}
      isModified={isModified}
      isVisible={isConfirmCancelModalVisible}
      customText={customText || 'If you leave this page, your changes will be discarded.'}
    />
  );

  return { renderConfirmation };
}
